import { useContext } from 'react'
import IngredientsCardMainElementContext from '@contexts/ingredientsCardMainElement'

const useIsIngredientsCardMainElement = (): boolean =>
  useContext(IngredientsCardMainElementContext)

export default useIsIngredientsCardMainElement
